const types = {
	//Get Template name
	GET_PUBLICFORMLIST_START: "GET_PUBLICFORMLIST_START",
	GET_PUBLICFORMLIST_SUCCESS: "GET_PUBLICFORMLIST_SUCCESS",
	GET_PUBLICFORMLIST_ERROR: "GET_PUBLICFORMLIST_ERROR",
	GET_PUBLICFORMLIST_RESET: "GET_PUBLICFORMLIST_RESET",

	//single item  name
	SELECT_TOUPDATE_ITEM: "SELECT_TOUPDATE_ITEM",
};

export default types;
